<template>
  <div v-if="author" class="c--blog_author blog-post-author d-flex flex-row align-items-start align-items-sm-center">
    <div :class="imageCropperClass">
      <img
        v-if="author.image && author.image.url"
        :data-src="author.image.url"
        src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
        class="blog-post-author-picture"
        alt=""
        v-lazy-load
      />
    </div>
    <div class="blog-post-author-name-wrapper d-flex flex-column">
      <span v-if="author.name" class="blog-post-author-name">
        {{ author.name }}
      </span>
      <p v-if="withBio && author.bio" class="opa-70">
        {{ author.bio }}
      </p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'author',
    props: ['author', 'withBio'],
    computed: {
      imageCropperClass: function () {
        let imageCropper = 'image-cropper'

        if (this.withBio) {
          imageCropper += ' image-cropper-lg'
        }

        return imageCropper
      },
    },
  }
</script>

<style lang="scss" scoped>
  .blog-post-author {
    margin: 9px 0;
  }
  .blog-post-author .image-cropper {
    width: 30px;
    height: 30px;
    position: relative;
    overflow: hidden;
    border-radius: 50%;
  }
  .blog-post-author .image-cropper-lg {
    width: 96px;
    height: 96px;
  }
  .blog-post-author-picture {
    display: inline;
    margin: 0 auto 0 -25%;
    height: 100%;
    width: auto;
    object-fit: cover;
  }
  .blog-post-author-name-wrapper {
    max-width: calc(100% - 100px);
    margin-left: 8px;

    [dir='rtl'] & {
      margin-left: unset;
      margin-right: 8px;
    }
  }
  .blog-post-author-name {
    color: #4a4a4a;
    font-weight: 600;
  }
</style>
